import type { Component } from 'vue';

export type NotificationType =
  | 'primary'
  | 'info'
  | 'link'
  | 'success'
  | 'warning'
  | 'danger';

type ComponentProps<C> = C extends abstract new (...args: never[]) => {
  $props: infer P;
}
  ? P
  : C extends (props: infer P, ...args: never[]) => unknown
    ? P
    : Record<string, never>;

export type NotificationChildProps<C extends Component> = Omit<
  ComponentProps<C>,
  'notification'
>;

export interface NotificationComponent {
  component: Component;
  props?: Record<string, unknown>;
}

export function notificationChild<C extends Component>(
  component: C,
  props: NotificationChildProps<C>,
): NotificationComponent {
  return { component, props: props as Record<string, unknown> };
}

export interface NotificationData {
  id: string;
  key: string;
  count: number;
  title?: string;
  text: string;
  timeout: number;
  type?: NotificationType;
  component?: NotificationComponent;
}

export interface OpenNotificationParams {
  title?: string;
  text: string;
  timeout?: number;
  type?: NotificationType;
  component?: NotificationComponent;
}
